import React from 'react';
import { LIBRARY_TYPES, LIBRARY_TYPE_ORDER } from '../../../models/LibraryModel';

/**
 * One tab per document type (PRD-1605). A tab changes the type and nothing
 * else. Each reserves its active width with a hidden copy of its label
 * (`data-label`, see Library.css), so the row doesn't shuffle.
 */
function LibraryTabs({ type, onSelect }) {
  return (
    <div className="library-tabs">
      {LIBRARY_TYPE_ORDER.map((key) => {
        const active = type === key;
        return (
          <button
            key={key}
            type="button"
            className={`library-tab${active ? ' is-active' : ''}`}
            aria-current={active ? 'true' : undefined}
            data-label={LIBRARY_TYPES[key].plural}
            onClick={() => onSelect(key)}
          >
            {LIBRARY_TYPES[key].plural}
          </button>
        );
      })}
    </div>
  );
}

export default LibraryTabs;
